import { render } from "./SilderItem.vue?vue&type=template&id=59ac8160&scoped=true"
import script from "./SilderItem.vue?vue&type=script&lang=js"
export * from "./SilderItem.vue?vue&type=script&lang=js"

import "./SilderItem.vue?vue&type=style&index=0&id=59ac8160&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ac8160"]])

export default __exports__